export function setLeaseId(state, leaseId) {
  state.leaseId = leaseId;
}

export function setApplication(state, application) {
  state.application = { ...application };
}

export function setCustomerOptions(state, customerOptions) {
  state.application = {
    ...state.application,
    metaData: { ...state.application.metaData, customerOptions }
  };
}

export function setApplicationLoading(state, value) {
  state.applicationLoading = value;
}

export function setApplicationSaving(state, value) {
  state.applicationSaving = value;
}

export function setGettingQuoteFile(state, value) {
  state.gettingQuoteFile = value;
}

export function updateCustomerOption(state, { field, value }) {
  let customerOptions = state.application.metaData.customerOptions;
  customerOptions = {
    ...customerOptions
  };
  customerOptions[field] = value;
  state.application.metaData.customerOptions = customerOptions;
}

export function updateQuoteUpload(state, { field, value }) {
  state.application = {
    ...state.application,
    metaData: {
      ...state.application.metaData,
      quoteUpload: {
        ...state.application.metaData.quoteUpload,
        [field]: value
      }
    }
  };
}

export function setCostsWeekly(state, costsWeekly) {
  state.application.metaData.costsWeekly = costsWeekly;
}

export function setQuickQuote(state, quickQuote) {
  state.quickQuote = {
    ...state.quickQuote,
    ...quickQuote
  };
}

export function setFinanceLoading(state, stateFlag) {
  state.financeLoading = stateFlag;
}

export function setGuardingNavigation(state, value) {
  state.guardingNavigation = value;
}

export function setSavingQuoteFile(state, value) {
  state.savingQuoteFile = value;
}

export function setSendingHRApproval(state, value) {
  state.sendingHRApproval = value;
}

export function setClearingApplication(state, value) {
  state.clearingApplication = value;
}

export function setSavingForExit(state, value) {
  state.savingForExit = value;
}
